<template>
<div class="egg">
   <div class="eggcontent">
      <div class="item" v-for="(o,i) in [{},{},{},{},{},{}]" v-bind:key="i">
         <img src="/static/images/egg1.png" v-on:click="eventZa(i)" />
         <img src="/static/images/egg2.png" class="img2" v-on:click="eventZa(i)" />
         <img src="/static/images/egg3.png" class="img3" />
      </div>
   </div>
   <div class="chui">
      <img :src="'/static/images/chui1.png'" />
   </div>
</div>
</template>
<script>
export default {
    data() {
        return{
            jumpi:0,
            stop: false,
            //限流
            isLim:true
        }
    },
    mounted() {
       this.init();
    },
    methods: {
       init:function(){
        //蛋跳
        this.jumpegg();
       },
        jumpegg:function(){
           //是否停止
            if(this.stop){
               return;
            }
            
            var curObj = document.querySelectorAll("div[class='eggcontent'] div");
            if(curObj.length>0){
               curObj[this.jumpi].querySelectorAll("img")[0].style.display="none";
               curObj[this.jumpi].querySelectorAll("img")[1].style.display="inline";
               setTimeout(()=>{
                     curObj[this.jumpi].querySelectorAll("img")[0].style.display="inline";
                     curObj[this.jumpi].querySelectorAll("img")[1].style.display="none";
                     
                     //重来
                     setTimeout(()=>{
                        this.jumpi = this.jumpi>4?0:(this.jumpi+1);
                        this.jumpegg();               
                     },500)
                     
                  },300);
            }
        },
        eventZa:function(i){
           this.$emit("childZa",i);
        },
        //砸金蛋限流
        eggZa:function(i){
           if(!this.isLim) {
              return;
           }           
           setTimeout(()=>{
              this.isLim = true;
           },3000);
           this.isLim = false;

           this.eventZaLim(i);
        },
        //砸金蛋
        eventZaLim:function(i){
           //停止跳动
           this.stop = true;

         var winWidth = document.body.offsetWidth;
         var curDiv = document.querySelectorAll("div[class='eggcontent'] div")[i];
           document.querySelectorAll("div[class='chui']")[0].style.top=curDiv.offsetTop+"px";
           document.querySelectorAll("div[class='chui']")[0].style.left=(curDiv.offsetLeft+(curDiv.offsetWidth/2))+"px";

           //锤一会后停止
           setTimeout(()=>{
              //蛋蛋爆炸
               curDiv.querySelectorAll("img")[0].style.display="none";
               curDiv.querySelectorAll("img")[2].style.display="inline";
               setTimeout(()=>{
                     //调用父组件函数
                     this.$emit("showtanchuan","data");
               },500);
           },1000);

        },
        //再来一次
        again:function(){
           //锤子回位
           document.querySelectorAll("div[class='chui']")[0].style.top='-2rem';
           document.querySelectorAll("div[class='chui']")[0].style.left='14rem';
           //所有蛋蛋回位
           document.querySelectorAll("div[class='eggcontent'] div").forEach(element => {
               element.querySelectorAll("img")[0].style.display="inline";
               element.querySelectorAll("img")[2].style.display="none";
           });
           //蛋蛋重新跳动
           this.stop = false;
           this.jumpegg();
        },
        //设置蛋蛋跳动状态
        setStopState:function(){
           //蛋蛋停止跳动
           this.stop = true;
           //锤子停止
           $(".chui").removeClass("chui").addClass("chuistop")
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/egg.vue